import env from "@/env";
import { useCallback, useState } from "react";
import { shouldRequireCaptcha } from "@/utils/captcha";

export function useCaptchaToken() {
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const [captchaResetCounter, setCaptchaResetCounter] = useState(0);
  const isCaptchaRequired = shouldRequireCaptcha({
    environment: env.ENVIRONMENT,
    enabledOutsideProduction: env.PASSWORDLESS_CAPTCHA_ENABLED
  });
  const isCaptchaComplete = !isCaptchaRequired || !!captchaToken;

  const getCaptchaToken = useCallback(async () => {
    if (!isCaptchaRequired) {
      return "";
    }
    if (!captchaToken) {
      throw new Error("Please complete the CAPTCHA.");
    }
    return captchaToken;
  }, [captchaToken, isCaptchaRequired]);

  const resetCaptcha = useCallback(() => {
    setCaptchaToken(null);
    setCaptchaResetCounter((prev) => prev + 1);
  }, []);

  return {
    captchaToken,
    captchaResetCounter,
    isCaptchaRequired,
    isCaptchaComplete,
    setCaptchaToken,
    getCaptchaToken,
    resetCaptcha
  };
}
